import React from 'react'
import {
	COLORS,
	IconButton,
	makeStyles,
	MaterialIcons,
} from '@monthio/react-components'
import { Theme } from '@material-ui/core/styles'

const useStyles = makeStyles<
	Theme,
	{ isSelected: boolean; isReported: boolean }
>(() => ({
	button: {
		width: '20px',
		height: '20px',
		background: ({ isSelected, isReported }) =>
			`${
				isReported
					? '#FFEED9'
					: isSelected
						? COLORS.BRAND_COLORS.HIGHLIGHT_BLUE
						: 'none'
			}`,
		border: ({ isSelected, isReported }) =>
			isReported
				? '2px solid #FFE1BF'
				: isSelected
					? `2px solid ${COLORS.BRAND_COLORS.DARK_PERIWINKLE}`
					: 'none',
	},
	icon: {
		color: ({ isReported, isSelected }) =>
			isReported
				? '#FF6B00'
				: isSelected
					? COLORS.BRAND_COLORS.DARK_PERIWINKLE
					: COLORS.TEXT_COLORS.DEFAULT,
	},
}))

export const ReportIcon = (styleProps: {
	isSelected: boolean
	isReported: boolean
}) => {
	const classes = useStyles(styleProps)

	return (
		<IconButton className={classes.button}>
			<MaterialIcons.ReportProblemOutlined
				fontSize="small"
				className={classes.icon}
			/>
		</IconButton>
	)
}
